import get from 'lodash/get';

class EnumController {
  static getLiteralKey(EnumObject, key) {
    if (key && key !== '') {
      const finded = get(EnumObject, key, null);
      return finded ? finded.literalKey : null;
    }
    return null;
  }

  static getValue(EnumObject, key) {
    if (key && key !== '') {
      const finded = get(EnumObject, key, null);
      return finded ? finded.value : null;
    }
    return null;
  }

  static getString(EnumObject, key, intl) {
    let output = '';
    const literal = EnumController.getLiteralKey(EnumObject, key);
    if (literal) {
      output = intl.formatMessage({ id: literal });
    }
    return output;
  }
}

export default EnumController;
